import React from 'react'

function SvgAddCustomer() {
  return (
    <div>
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M4.7723 11.614V7.412H0.878297V5.146H4.7723V0.921999H7.2363V5.146H11.1303V7.412H7.2363V11.614H4.7723Z"
        fill="#BFCBDD"
      />
    </svg></div>
  )
}

export default SvgAddCustomer